import { render, staticRenderFns } from "./RecommendDetail.vue?vue&type=template&id=27cb55f1&scoped=true"
import script from "./RecommendDetail.vue?vue&type=script&lang=js"
export * from "./RecommendDetail.vue?vue&type=script&lang=js"
import style0 from "./RecommendDetail.vue?vue&type=style&index=0&id=27cb55f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cb55f1",
  null
  
)

export default component.exports